<template >
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;">Relatórios de estudantes</v-card-title>
          <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
          <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1"> Estudantes cadastrados </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :value="'tab-1'"> <cadastro-estudantes></cadastro-estudantes> </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import cadastroEstudantes from '../relatorios/relatorioComponentes/cadastroEstudantes.vue'

export default {
  components: {
    cadastroEstudantes
  },
  data: () => ({
    valid: true,
    isLoading: false,
    tab: 1    
  }),
}
</script>
 
<style scoped>
.bg {
  color: green;
  background: red
}
</style>
